import { createClient, SupabaseClient } from '@supabase/supabase-js';

const supabaseUrl = import.meta.env.VITE_SUPABASE_URL || '';
const supabaseAnonKey = import.meta.env.VITE_SUPABASE_ANON_KEY || '';

export const SUPABASE_URL = supabaseUrl;
export const isSupabaseConfigured = Boolean(supabaseUrl && supabaseAnonKey);

if (!isSupabaseConfigured) {
  console.warn('Supabase credentials not configured. Please set VITE_SUPABASE_URL and VITE_SUPABASE_ANON_KEY');
}

export const supabase: SupabaseClient = isSupabaseConfigured 
  ? createClient(supabaseUrl, supabaseAnonKey, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: false,
        storage: typeof window !== 'undefined' ? window.localStorage : undefined,
        flowType: 'pkce',
      },
    })
  : null as unknown as SupabaseClient;

export type SubscriptionStatus = 'free' | 'trialing' | 'active' | 'past_due' | 'canceled' | null;

export interface UserProfile {
  id: string;
  email: string;
  subscription_status: SubscriptionStatus;
  needs_password_reset: boolean;
  stripe_account_id?: string;
  created_at: string;
  updated_at: string;
}

export function hasFullAccess(status: SubscriptionStatus): boolean {
  return status === 'active' || status === 'trialing' || status === 'past_due';
}

export const FREE_TIER_LIMITS = {
  maxCalorieScans: 3,
  maxVisibleMeals: 1,
  maxVisibleRecipes: 15,
};
